import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

interface IProps {
  id: string;
}

export const WWWeaponImage: React.FC<IProps> = ({ id }) => {
  return (
    <>
      {id === '21040036' && (
        <StaticImage
          src="../../../images/ww/weapons/21040036.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050056' && (
        <StaticImage
          src="../../../images/ww/weapons/21050056.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020046' && (
        <StaticImage
          src="../../../images/ww/weapons/21020046.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020036' && (
        <StaticImage
          src="../../../images/ww/weapons/21020036.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050046' && (
        <StaticImage
          src="../../../images/ww/weapons/21050046.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050027' && (
        <StaticImage
          src="../../../images/ww/weapons/21050027.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050017' && (
        <StaticImage
          src="../../../images/ww/weapons/21050017.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040026' && (
        <StaticImage
          src="../../../images/ww/weapons/21040026.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030016' && (
        <StaticImage
          src="../../../images/ww/weapons/21030016.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050094' && (
        <StaticImage
          src="../../../images/ww/weapons/21050094.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040094' && (
        <StaticImage
          src="../../../images/ww/weapons/21040094.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030094' && (
        <StaticImage
          src="../../../images/ww/weapons/21030094.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020094' && (
        <StaticImage
          src="../../../images/ww/weapons/21020094.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010094' && (
        <StaticImage
          src="../../../images/ww/weapons/21010094.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020017' && (
        <StaticImage
          src="../../../images/ww/weapons/21020017.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020026' && (
        <StaticImage
          src="../../../images/ww/weapons/21020026.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030084' && (
        <StaticImage
          src="../../../images/ww/weapons/21030084.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050084' && (
        <StaticImage
          src="../../../images/ww/weapons/21050084.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010084' && (
        <StaticImage
          src="../../../images/ww/weapons/21010084.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040084' && (
        <StaticImage
          src="../../../images/ww/weapons/21040084.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020084' && (
        <StaticImage
          src="../../../images/ww/weapons/21020084.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050036' && (
        <StaticImage
          src="../../../images/ww/weapons/21050036.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040016' && (
        <StaticImage
          src="../../../images/ww/weapons/21040016.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050026' && (
        <StaticImage
          src="../../../images/ww/weapons/21050026.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010063' && (
        <StaticImage
          src="../../../images/ww/weapons/21010063.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020016' && (
        <StaticImage
          src="../../../images/ww/weapons/21020016.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010026' && (
        <StaticImage
          src="../../../images/ww/weapons/21010026.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050016' && (
        <StaticImage
          src="../../../images/ww/weapons/21050016.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010044' && (
        <StaticImage
          src="../../../images/ww/weapons/21010044.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040044' && (
        <StaticImage
          src="../../../images/ww/weapons/21040044.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040043' && (
        <StaticImage
          src="../../../images/ww/weapons/21040043.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010023' && (
        <StaticImage
          src="../../../images/ww/weapons/21010023.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040053' && (
        <StaticImage
          src="../../../images/ww/weapons/21040053.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040015' && (
        <StaticImage
          src="../../../images/ww/weapons/21040015.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050015' && (
        <StaticImage
          src="../../../images/ww/weapons/21050015.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020044' && (
        <StaticImage
          src="../../../images/ww/weapons/21020044.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030044' && (
        <StaticImage
          src="../../../images/ww/weapons/21030044.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050044' && (
        <StaticImage
          src="../../../images/ww/weapons/21050044.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010064' && (
        <StaticImage
          src="../../../images/ww/weapons/21010064.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020064' && (
        <StaticImage
          src="../../../images/ww/weapons/21020064.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010015' && (
        <StaticImage
          src="../../../images/ww/weapons/21010015.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030064' && (
        <StaticImage
          src="../../../images/ww/weapons/21030064.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040064' && (
        <StaticImage
          src="../../../images/ww/weapons/21040064.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050064' && (
        <StaticImage
          src="../../../images/ww/weapons/21050064.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010013' && (
        <StaticImage
          src="../../../images/ww/weapons/21010013.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020013' && (
        <StaticImage
          src="../../../images/ww/weapons/21020013.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030013' && (
        <StaticImage
          src="../../../images/ww/weapons/21030013.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040013' && (
        <StaticImage
          src="../../../images/ww/weapons/21040013.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050013' && (
        <StaticImage
          src="../../../images/ww/weapons/21050013.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030043' && (
        <StaticImage
          src="../../../images/ww/weapons/21030043.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020023' && (
        <StaticImage
          src="../../../images/ww/weapons/21020023.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030023' && (
        <StaticImage
          src="../../../images/ww/weapons/21030023.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050053' && (
        <StaticImage
          src="../../../images/ww/weapons/21050053.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030053' && (
        <StaticImage
          src="../../../images/ww/weapons/21030053.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010053' && (
        <StaticImage
          src="../../../images/ww/weapons/21010053.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030034' && (
        <StaticImage
          src="../../../images/ww/weapons/21030034.webp"
          alt="Weapon Image"
        />
      )}
      {id === '210200343' && (
        <StaticImage
          src="../../../images/ww/weapons/21020034.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010011' && (
        <StaticImage
          src="../../../images/ww/weapons/21010011.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020011' && (
        <StaticImage
          src="../../../images/ww/weapons/21020011.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030011' && (
        <StaticImage
          src="../../../images/ww/weapons/21030011.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040011' && (
        <StaticImage
          src="../../../images/ww/weapons/21040011.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050011' && (
        <StaticImage
          src="../../../images/ww/weapons/21050011.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020012' && (
        <StaticImage
          src="../../../images/ww/weapons/21020012.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010012' && (
        <StaticImage
          src="../../../images/ww/weapons/21010012.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030012' && (
        <StaticImage
          src="../../../images/ww/weapons/21030012.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040012' && (
        <StaticImage
          src="../../../images/ww/weapons/21040012.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050012' && (
        <StaticImage
          src="../../../images/ww/weapons/21050012.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030074' && (
        <StaticImage
          src="../../../images/ww/weapons/21030074.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020074' && (
        <StaticImage
          src="../../../images/ww/weapons/21020074.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020034' && (
        <StaticImage
          src="../../../images/ww/weapons/21020034.webp"
          alt="Weapon Image"
        />
      )}
      {id === '221050023' && (
        <StaticImage
          src="../../../images/ww/weapons/21050023.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020053' && (
        <StaticImage
          src="../../../images/ww/weapons/21020053.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010024' && (
        <StaticImage
          src="../../../images/ww/weapons/21010024.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020024' && (
        <StaticImage
          src="../../../images/ww/weapons/21020024.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030024' && (
        <StaticImage
          src="../../../images/ww/weapons/21030024.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040024' && (
        <StaticImage
          src="../../../images/ww/weapons/21040024.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050024' && (
        <StaticImage
          src="../../../images/ww/weapons/21050024.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010043' && (
        <StaticImage
          src="../../../images/ww/weapons/21010043.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020043' && (
        <StaticImage
          src="../../../images/ww/weapons/21020043.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050043' && (
        <StaticImage
          src="../../../images/ww/weapons/21050043.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050034' && (
        <StaticImage
          src="../../../images/ww/weapons/21050034.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040034' && (
        <StaticImage
          src="../../../images/ww/weapons/21040034.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010034' && (
        <StaticImage
          src="../../../images/ww/weapons/21010034.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010016' && (
        <StaticImage
          src="../../../images/ww/weapons/21010016.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040023' && (
        <StaticImage
          src="../../../images/ww/weapons/21040023.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050074' && (
        <StaticImage
          src="../../../images/ww/weapons/21050074.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21020015' && (
        <StaticImage
          src="../../../images/ww/weapons/21020015.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21030015' && (
        <StaticImage
          src="../../../images/ww/weapons/21030015.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21040074' && (
        <StaticImage
          src="../../../images/ww/weapons/21040074.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21010074' && (
        <StaticImage
          src="../../../images/ww/weapons/21010074.webp"
          alt="Weapon Image"
        />
      )}
      {id === '21050023' && (
        <StaticImage
          src="../../../images/ww/weapons/21050023.webp"
          alt="Weapon Image"
        />
      )}
    </>
  );
};
